import React from "react";
import { Outlet } from "react-router-dom";

export default function MainContent() {
  return (
    // <Theme theme={theme}>
    <div className="main-content">
      {/*<NavBarVertical />*/}
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
    // </Theme>
  );
}
